import { PTabs, PTabsItem, type PTabsProps } from '@porsche-design-system/components-react';
import { useCallback, useMemo } from 'react';
import { type TabsProps } from '../default/Tabs';

const getPorscheTabsSizeFromAntdSize = (size: TabsProps['size']): PTabsProps['size'] => {
    switch (size) {
        case 'small':
            return 'small';

        case 'middle':
        case 'large':
            return 'medium';

        default:
            return undefined;
    }
};

const Tabs = ({ items = [], size, activeKey, defaultActiveKey, weight, onChange }: TabsProps) => {
    const activeTabIndex = useMemo(() => {
        const index =
            items.findIndex(item => item.key === activeKey) ?? items.findIndex(item => item.key === defaultActiveKey);

        return index === -1 ? 0 : index;
    }, [items, activeKey, defaultActiveKey]);

    const onUpdate: PTabsProps['onUpdate'] = useCallback(
        event => {
            if (!onChange) {
                return;
            }

            const { activeTabIndex } = event.detail;

            onChange(items[activeTabIndex]?.key);
        },
        [items, onChange]
    );

    return (
        <PTabs
            activeTabIndex={activeTabIndex}
            onUpdate={onUpdate}
            size={getPorscheTabsSizeFromAntdSize(size)}
            weight={weight}
        >
            {items.map(item => (
                <PTabsItem key={item.key} label={item.label}>
                    {item.children}
                </PTabsItem>
            ))}
        </PTabs>
    );
};

export default Tabs;
